<template>
  <ul class="swatches">
    <li v-for="(color, index) in colors" :key="index">
      <label
        :qaid="`color-swatch-label-${color}`"
        class="swatch"
        :class="{'cursor-default': displayOnly}"
        :for="`${radioName}-swatch-${color}`"
        :title="color"
      >
        <input
          :id="`${radioName}-swatch-${color}`"
          v-model="active"
          type="radio"
          :aria-label="`${color} swatch`"
          class="swatch__radio"
          :data-color="color"
          data-id="#"
          data-url="#"
          :name="radioName"
          :value="color"
          :disabled="displayOnly"
          @change="onChange"
        />
        <span class="swatch__decorator" :class="[displayOnly ? 'cursor-default' : '', `swatch-${color}`]"></span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    displayOnly: Boolean,
    changecolor: {
      type: Function,
      default: () => true,
    },
    activeColor: {
      type: String,
      default: '',
    },
    colors: {
      type: Array,
      default: function() {
        return [
          'red',
          'tan',
          'greenlight',
          'white',
          'green',
          'orange',
          'pink',
          'black',
          'greendark',
          'grey_reflective',
          'greylight',
          'bronze',
          'greenlight_grey',
          'bluelight',
          'greenvisibility',
        ];
      },
    },
    radioName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      active: this.activeColor ? this.activeColor : !this.displayOnly ? this.colors[0] : null,
    };
  },

  mounted() {
    this.onChange();
  },

  methods: {
    onChange() {
      if (this.changecolor) {
        this.changecolor(this.active);
      }
      this.$emit('color-changed', this.active);
    },
  },
};
</script>
